import { apiFetch } from '@/platform/lib/api';
import { publicUrlForObjectPath } from '@/platform/blog/uploads';

export const FORUM_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const FORUM_IMAGE_ACCEPT = 'image/*';
export const MAX_FORUM_IMAGES = 4;

export async function uploadForumImage(file: File): Promise<{ objectPath: string; publicUrl: string }> {
  if (file.size > FORUM_IMAGE_MAX_BYTES) {
    throw new Error('Image must be 5 MB or smaller.');
  }
  if (!file.type.startsWith('image/')) {
    throw new Error('Only image files are allowed. Add a YouTube URL for video.');
  }

  const signed = await apiFetch<{
    uploadUrl: string;
    objectPath: string;
    publicUrl?: string;
  }>('/uploads/signed-url', {
    method: 'POST',
    body: JSON.stringify({
      purpose: 'forum',
      filename: file.name,
      contentType: file.type || 'image/jpeg',
      sizeBytes: file.size,
    }),
  });

  if (!signed.uploadUrl.includes('signed=stub')) {
    const put = await fetch(signed.uploadUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type || 'image/jpeg' },
    });
    if (!put.ok) {
      throw new Error('Upload failed');
    }
  }

  return {
    objectPath: signed.objectPath,
    publicUrl: signed.publicUrl || publicUrlForObjectPath(signed.objectPath),
  };
}
